import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'redux-first-router-link';

export const CuiPaginationButton = ({ className, isPrevious, to, ...rest }) => {
  const classes = classNames('cuiPaginationButton', {
    'cuiPaginationButton--previous': isPrevious,
    'cuiPaginationButton--next': !isPrevious,
    'cuiPaginationButton-isDisabled': !to,
  });

  return <Link className={classes} to={to} {...rest} />;
};

CuiPaginationButton.propTypes = {
  className: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isPrevious: PropTypes.bool,
};

CuiPaginationButton.defaultProps = {
  className: undefined,
  to: '',
  isPrevious: false,
};



// WEBPACK FOOTER //
// ./ui/components/pagination/PaginationButton.js